
       
<div>
    <div class="flex mb-2">
        <input id="omnisearch_orglist" pInputText placeholder="Cerca" [ngModel]="filter().shortDescription" (ngModelChange)="onSearchByShortDesc($event)" class="w-full"/>
    </div>
    <div class="mb-4">
        <spike-etiquette-list 
            noLabelName="Tutti"
            [selectedId]="filter().etiquetteId" 
            [etiquetteList]="entityEtiquetteList()" 
            (onSelect)="searchByEtiquette($event)">
        </spike-etiquette-list>
    </div>

    <div class="w-full mb-4">
        <p-button severity ="primary" class="w-full" styleClass="w-full"  (onClick)="isSidepanelVisibile.set(true)">Nuovo</p-button>
    </div>
    @if(entityList() && entityList().length>0){
    <div>
        @for (item of entityList(); track $index) {
            <div (click)="onSelect.emit(item)" class="cursor-pointer mb-2 spike-list-item flex justify-between items-center">
                <div>{{item.shortDescription}}</div>
                <p-button icon="pi pi-external-link" [text]="true" severity ="secondary" size="small" (onClick)="$event.stopPropagation();selectDetailItem(item)"></p-button>
            </div>
        }
    </div>
    }
    @else {
        <spike-no-result></spike-no-result>
    }
    
</div>
@if(isSidepanelVisibile()){
<spike-organization-side-panel 
    [entityApi]="entityApi()"
    [modelApi]="modelApi()"
    [etiquetteApi]="etiquetteApi()"
    [entityKey]="entityKey()" 
    [isDialogVisible]="isSidepanelVisibile()" 
    [dataId]="selectedItem()!"  
    (onSave)="onSave()"
    (onClose)="closeSidePanel()">
</spike-organization-side-panel>
}